import "@hotwired/turbo-rails"
import "./controllers"
import Swal from "sweetalert2"
window.Swal = Swal
import Chartkick from "chartkick"
import "chartkick/chart.js"
window.Chartkick = Chartkick
